const CompanyHistory = ({ title, subtitle, events }) => {
  return (
    <section className="py-20 bg-white text-text">
      <div className="max-w-[1140px] mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl tracking-[4px] uppercase text-primary font-light mb-4">
            {title}
          </h2>
          <p className="text-xl font-gilda text-darkBackground">{subtitle}</p>
        </div>

        {/* Timeline container */}
        <div className="relative">
          {/* Center vertical line */}
          <div className="absolute left-1/2 top-0 h-full w-[2px] bg-primary z-0 transform -translate-x-1/2" />

          {/* Timeline items */}
          <div className="space-y-16">
            {events.map((event, index) => {
              const isLeft = index % 2 === 0;

              return (
                <div key={index} className="relative flex flex-col md:flex-row ">
                  {/* Line dot */}
                  <div className="absolute left-1/2 transform -translate-x-1/2 z-10">
                    <div className="w-4 h-4 rounded-full bg-primary border-4 border-white shadow-md" />
                  </div>

                  {/* Content */}
                  <div
                    className={`w-full md:w-1/2 px-6 py-6 shadow-lg bg-background z-10 ${
                      isLeft ? 'relative md:pr-16 text-center lg:text-right md:self-end lg:mr-[40px]' : 'relative md:pl-16 text-center lg:text-left md:self-start lg:left-[50%] lg:ml-[20px]'
                    }`}
                  >
                    <h3 className="text-xl text-primary font-light font-gilda mb-2">{event.year}</h3>
                    <p className="text-light text-black leading-relaxed">{event.description}</p>
                  </div>

                  {/* Spacer div for symmetry */}
                  <div className="hidden md:block w-1/2" />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanyHistory;
